import { render, staticRenderFns } from "./SettingView.vue?vue&type=template&id=492bbc6a&scoped=true"
import script from "./SettingView.vue?vue&type=script&lang=js"
export * from "./SettingView.vue?vue&type=script&lang=js"
import style0 from "./SettingView.vue?vue&type=style&index=0&id=492bbc6a&prod&scoped=true&lang=css"
import style1 from "./SettingView.vue?vue&type=style&index=1&id=492bbc6a&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "492bbc6a",
  null
  
)

export default component.exports